/* unplugin-vue-components disabled */import { render } from "./AutoLogin.vue?vue&type=template&id=4546146e&scoped=true&ts=true"
import script from "./AutoLogin.vue?vue&type=script&lang=ts"
export * from "./AutoLogin.vue?vue&type=script&lang=ts"

import "./AutoLogin.vue?vue&type=style&index=0&id=4546146e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4546146e"]])

export default __exports__